import React from "react";
import Headline from "../components/shared/Headline";
import LocationsApi from "../../api-services/locations-api.service";
import { Flex, notification } from "antd";
import LocationPostcards from "../components/shared/LocationPostcards";

const bannerPath = '/iceholidays-assets/images/about_us.png';
const breadcrumbs = [
  { title: 'Home' },
  { title: 'Countries' }
] 


export default class CountriesPage extends React.Component {
  locationsApi = new LocationsApi;

  state = {
    countries: []
  }

  componentDidMount() {
    this.locationsApi.getCountries()
      .then(locationsData => {
        this.setState({countries: locationsData})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
  }


  render(){
    return (
      <div id="countries-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Countries"/>

        <div id="countries-page_body">
          <div id="introduction">
            <Flex vertical gap={24}>
              <div id="introduction_header"> <img src="/iceholidays-assets/images/logomark.png"/> <span> The Signature Tours </span> </div>
              <div id="introduction_body">
                <p>Immerse yourself in the art of travel with The Signature Tour. Every experience is meticulously designed to create memories that last a lifetime.
                Our journeys go beyond the ordinary, offering experiences that are as unique as you are.</p>
                
                <p>From charming accommodations to curated cultural encounters, every aspect is thoughtfully crafted to elevate your travel experience. At The Signature Tour, we believe in the S-Tour’s philosophy —where every moment is a signature memory.</p>
              </div>
            </Flex>
          </div>

          <h2> Countries </h2>
          <LocationPostcards locations={this.state.countries}/>
        </div>

      </div>
    )
  }
}